import { render, staticRenderFns } from "./DeleteResellerConfirmDialog.vue?vue&type=template&id=9832f46c&scoped=true&lang=pug&"
import script from "./DeleteResellerConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteResellerConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteResellerConfirmDialog.vue?vue&type=style&index=0&id=9832f46c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9832f46c",
  null
  
)

export default component.exports